<template>
  <svg
    class="AtlasIcon"
    :class="`AtlasIcon--${name}`"
    viewBox="0 0 24 24"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <title v-if="caption">{{ caption }}</title>
    <path v-if="d" :d="d" />
  </svg>
</template>

<script>
import ICONS from '../../conf/icons.json';

export default {
  name: 'atlas-icon',

  props: {
    name: {
      type: String,
      required: true,
    },

    size: {
      type: Number,
      default: 22,
    },

    caption: {
      type: String,
      required: false,
    },
  },

  computed: {
    d() {
      return ICONS[this.name];
    },
  },
};
</script>

<style lang="scss">
.AtlasIcon {
  fill: currentColor;
  vertical-align: middle;
}
</style>
